import React from 'react';
import { Route, Switch } from 'react-router-dom';
import loadable from '@loadable/component';

import PageLoading from '~app/components/PageLoading';

const USER_ROUTES = {
  marketingEmailPreferences: { path: '/user/email-preferences' },
  teamDiscovery: { path: '/user/discover-teams' },
};

const MarketingEmailPreferences = loadable(
  () => import(/* webpackChunkName: 'coreweb-user-marketing-email-preferences' */ './MarketingEmailPreferences'),
  {
    fallback: <PageLoading />,
  }
);

const TeamDiscovery = loadable(() => import(/* webpackChunkName: 'coreweb-user-team-discovery' */ './TeamDiscovery'), {
  fallback: <PageLoading />,
});

const User = () => {
  return (
    <Switch>
      <Route path={USER_ROUTES.marketingEmailPreferences.path} component={MarketingEmailPreferences} />
      <Route path={USER_ROUTES.teamDiscovery.path} component={TeamDiscovery} />
    </Switch>
  );
};

export default User;
